<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>{{file.file}}</strong>
        </div>
        <tree-view v-if="file != null" :data="content" :options="{maxDepth: 3, rootObjectKey: 'Log Content'}"></tree-view>
        <b-col col-sm-12>
            <button class="btn btn-primary" style="float: right" @click="goBack()">Voltar</button>
        </b-col>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      clientId: null,
      loadCount: 0,
      file: {},
      files: {},
      content: {},
      teste: {}
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  mounted() {
      this.getContent();
  },
  methods: {
      goBack() {
          const self = this;
          self.$router.push({
            name: 'Logs do utilitário',
            params: {
                files: self.files
            }
        });
      },
      getContent() {
          const self = this;

          self.file = this.$route.params.file;
          self.files = this.$route.params.files;
          self.content = JSON.parse(self.file.content);
          console.log(self.content);
      }
  }
}
</script>
